import { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  getConversation,
  getConversationMessages,
  postConversationMessage,
  updateConversation,
  updateConversationDisplayName,
  archiveConversation,
} from 'actions/conversations';
import { selectConversationMessages, selectConversation } from 'selectors';
import MessagesHeader from 'components/MessagesHeader';
import MessageForm from 'components/MessageForm';
import ConversationMessages from 'components/ConversationMessages';
import Drawer from 'components/Drawer';
import ConversationDetails from 'components/ConversationDetails';
import values from 'lodash/values';
import { history } from 'store';
import trim from 'lodash/trim';
import stripHtml from 'string-strip-html';
import { withTranslation } from 'react-i18next';
import { getPathSlug } from '../../../utils/routes';
import Breadcrumb from '../../../components/Breadcrumb';
import { PageHeader } from '../../../ui';

const Wrapper = styled.div``;

class CommunityMessages extends Component {
  state = {
    attachments: [],
    messageBody: '',
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { match } = this.props;

    if (match.params.id !== prevProps.match.params.id) {
      this.loadData();
    }
  }

  handleUpdateMessageBody = messageBody => {
    this.setState({ messageBody });
  };

  loadData = async () => {
    const { match, getConversation, getConversationMessages } = this.props;

    getConversation(match.params.id);
    getConversationMessages(match.params.id);
  };

  handleSubmitMessage = async e => {
    e.preventDefault();

    const { messageBody, attachments } = this.state;
    const { match, postConversationMessage } = this.props;
    const conversationId = match.params.id;

    const body = trim(stripHtml(messageBody));
    let message = {};

    if (Boolean(body)) {
      message = { ...message, body };
    }

    if (attachments.length > 0) {
      message = {
        ...message,
        attachmentIds: attachments.map(({ id }) => id),
      };
    }

    if (attachments.length === 0 && !Boolean(body)) {
      return;
    }

    try {
      this.setState({ isSubmitting: true });
      await postConversationMessage(conversationId, message);
      this.setState({ messageBody: '', attachments: [] });
    } catch (e) {}

    this.setState({ isSubmitting: false });
  };

  handleAddMembers = async addedMembers => {
    const { conversation, updateConversation } = this.props;
    const { id, members } = conversation;

    const payload = {
      memberIds: [
        ...members.map(({ id }) => id),
        ...addedMembers.map(({ id }) => id),
      ],
    };

    return await updateConversation(id, payload);
  };

  handleAddAttachment = attachment => {
    const { attachments } = this.state;

    this.setState({ attachments: [...attachments, attachment] });
  };

  handleRemoveAttachment = removeId => {
    const { attachments } = this.state;

    this.setState({
      attachments: attachments.filter(({ id }) => id !== removeId),
    });
  };

  handleArchiveConversation = async () => {
    const { match, archiveConversation } = this.props;
    const { id } = match.params;

    await archiveConversation(id);
    history.push(`/mes-echanges/mes-messages`);
  };

  render() {
    const { messages, conversation, match, t } = this.props;
    const { url } = match;
    const { memberId } = match.params;
    const { messageBody, isSubmitting } = this.state;

    const customTranslations = {
      [getPathSlug(url)]: conversation.displayName,
    };

    return (
      <Wrapper>
        <PageHeader hideOnDesktop>
          <Breadcrumb bareHorizontal customTranslations={customTranslations} />
        </PageHeader>

        <MessagesHeader
          {...conversation}
          onRequestInfo={() => this.setState({ drawerIsShown: true })}
        />

        <ConversationMessages messages={messages} />

        <MessageForm
          attachments={this.state.attachments}
          value={messageBody}
          onChange={this.handleUpdateMessageBody}
          onSubmit={this.handleSubmitMessage}
          onAddAttachment={this.handleAddAttachment}
          onRemoveAttachment={this.handleRemoveAttachment}
          isSubmitting={isSubmitting}
        />

        <Drawer
          shown={values(match.params).indexOf('details') > -1}
          title={t('drawer')}
          onRequestClose={() =>
            history.push(`/mes-echanges/mes-messages/${conversation.id}`)
          }
        >
          <ConversationDetails
            {...conversation}
            memberId={memberId}
            onAddMembers={this.handleAddMembers}
            onUpdateName={this.props.updateConversationDisplayName}
            onArchive={this.handleArchiveConversation}
          />
        </Drawer>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, props) => ({
  conversation: selectConversation(state, props),
  messages: selectConversationMessages(state, props),
});

const mapDispatchToProps = dispatch => ({
  getConversation: id => dispatch(getConversation(id)),
  archiveConversation: id => dispatch(archiveConversation(id)),
  updateConversation: (...args) => dispatch(updateConversation(...args)),
  getConversationMessages: id => dispatch(getConversationMessages(id)),
  postConversationMessage: (...args) =>
    dispatch(postConversationMessage(...args)),
  updateConversationDisplayName: (...args) =>
    dispatch(updateConversationDisplayName(...args)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation('conversation')(CommunityMessages)),
);
